// extracted by mini-css-extract-plugin
module.exports =  {"container":"vertical_card_content-module_container_db95a","threePart":"vertical_card_content-module_threePart_b2b8f","twoPart":"vertical_card_content-module_twoPart_c71e9"};